
import { z } from "zod";

export const AblyConnectionStateValues = ["initialized", "connecting", "connected", "disconnected", "suspended", "closing", "closed", "failed"] as const;
export const AblyConnectionStateSchema = /* @__PURE__ */ z.enum(AblyConnectionStateValues);
export const AblyConnectionState: (typeof AblyConnectionStateSchema)["enum"] = { "initialized": "initialized", "connecting": "connecting", "connected": "connected", "disconnected": "disconnected", "suspended": "suspended", "closing": "closing", "closed": "closed", "failed": "failed" };
export type AblyConnectionState = (typeof AblyConnectionStateValues)[number];
